import { ROUTES } from '@/constants/routes';
import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '../core';
import { useParams } from 'react-router-dom';
import { BankAccountAggregateInfo } from '@/types/bankAccounts';

type BankAccountDetailsViewProps = {
  aggregateInfo: BankAccountAggregateInfo;
};

export default function BankAccountDetailsView({
  aggregateInfo,
}: BankAccountDetailsViewProps) {
  const { uuid = '' } = useParams();

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        View
      </Typography>
      <Stack spacing={2}>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}/${uuid}${ROUTES.TRANSACTIONS}`}>
          Transactions
        </SVLink>
        <SVLink
          to={`${ROUTES.BANK_ACCOUNTS}/${uuid}${ROUTES.SCHEDULED_TRANSACTIONS}`}>
          Scheduled Transactions
        </SVLink>
        <SVLink
          to={`${ROUTES.BANK_ACCOUNTS}/${uuid}${ROUTES.TRANSACTION_REQUESTS}`}>
          Transaction Requests ({aggregateInfo.totalTransactionRequests})
        </SVLink>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}/${uuid}${ROUTES.STATEMENTS}`}>
          Statements ({aggregateInfo.totalStatements})
        </SVLink>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}/${uuid}${ROUTES.TAX_DOCUMENTS}`}>
          Tax Documents
        </SVLink>
      </Stack>
    </Card>
  );
}
